import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faMap, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, Tickets, MapPin, Info, Copy, ChevronDown, ChevronUp } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits, formatUTCDateTime } from '../common/function';
import { changeAlramModal, changecouponTab, checkDuplicateLogins } from '../../store';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Barcode from 'react-barcode';
import FallbackImage from '../common/FallbackImage';

function CouponDetail_Soda() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { couponId } = useParams();

    const shoppingState = useSelector((state) => state.shoppingState.value);

    const location = useLocation();
    const coupon = location.state?.coupon;

    const JWT = useSelector((state) => state.JWT.value);

    const [activeTab, setActiveTab] = useState(0);
    const [textBox, setTextBox] = useState(true);
    const [noticeBox, setNoticeBox] = useState(false);
    const [messageDrop, setMessageDrop] = useState(false)

    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!coupon) {
            navigate('/coupons')
        }
    }, [coupon])

    const onBack = () => {
        navigate(-1);
    };

    const onDelete = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/sodagift/coupon/user/remove', {
            coupon_no: coupon.no
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            // console.log(tmp)
            if (tmp?.success) {
                setMessage({ "code": 0, "msg": tmp?.message ?? "Success" })
                dispatch(changeAlramModal())
                onBack()
            }
            else {
                setMessage({ "code": 1, "msg": tmp?.message ?? "Fail" })
                dispatch(changeAlramModal())
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const handleDelete = () => {
        if (window.confirm(t('coupons_4'))) {
            onDelete();
        }
    };

    // 예시: 지도로 이동하기
    const handleClickMap = () => {
        const brand = encodeURIComponent(coupon.ci_brand_name);
        const url = `https://www.google.com/maps/search/?api=1&query=${brand}`;

        if (window.Telegram?.WebApp?.openLink) {
            // 텔레그램 미니앱
            window.Telegram.WebApp.openLink(url);
        } else {
            // 일반 브라우저
            window.open(url, '_blank');
        }
    };

    const handleClickUseLink = () => {
        if (window.confirm("It will be marked as used and can be found on the Used tab.")) {
            const url = coupon.uc_gift_url;

            if (window.Telegram?.WebApp?.openLink) {
                // 텔레그램 미니앱
                window.Telegram.WebApp.openLink(url);
            } else {
                // 일반 브라우저
                window.open(url, '_blank');
            }
            handleClickComplete()
        }
    };

    const handleClickComplete = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/sodagift/coupon/user/use-complete', {
            coupon_no: coupon.no
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            // console.log(tmp)
            if (tmp?.success) {
                setMessage({ "code": 0, "msg": tmp?.message ?? "Success" })
                dispatch(changeAlramModal())
                dispatch(changecouponTab(1))
                onBack()
            }
            else {
                setMessage({ "code": 1, "msg": tmp?.message ?? "Fail" })
                dispatch(changeAlramModal())
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const handleClickAvailable = async () => {
        if (window.confirm("Do you want to change the status to Available?")) {
            await axios.post(process.env.REACT_APP_API + '/api/sodagift/coupon/user/use-complete-cancel', {
                coupon_no: coupon.no
            }, {
                headers: { Authorization: `Bearer ${JWT}` }
            }).then((response) => {
                let tmp = response.data
                // console.log(tmp)
                if (tmp?.success) {
                    setMessage({ "code": 0, "msg": tmp?.message ?? "Success" })
                    dispatch(changeAlramModal())
                    dispatch(changecouponTab(0))
                    onBack()
                }
                else {
                    setMessage({ "code": 1, "msg": tmp?.message ?? "Fail" })
                    dispatch(changeAlramModal())
                }
            }).catch((error) => {
                if (error?.status === 999) {
                    dispatch(checkDuplicateLogins(true))
                }
                else {
                    console.log(error)
                }
            })
        }
    };

    const handleClickCoupy = () => {
        navigator.clipboard.writeText(coupon.uc_gift_url)
        setMessage({ "code": 0, "msg": "Copy" })
        dispatch(changeAlramModal())
    };

    // 쿠폰이 없으면 로딩 or 에러
    if (!coupon) {
        return (
            <div style={{ padding: "20px" }}>
                Shop Now
            </div>
        );
    }

    return (
        <div
            className="friend"
            style={{
                background: "#f5f5f5",
                padding: "0px",
                position: "relative",
            }}
        >
            <div style={{ padding: '0px', paddingBottom: '60px', fontFamily: 'sans-serif' }}>
                <MessageModal message={message} />
                {/* 고정된 상단 헤더 */}
                <div
                    style={{
                        position: 'fixed',
                        top: "0px",
                        left: "0px",
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: "50px",
                        background: "#fff",
                        padding: "0 15px",
                        zIndex: "10",
                        borderBottom: "1px solid #dddddd"
                    }}
                >
                    {/* 뒤로가기 버튼 */}
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            left: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0 });
                        }}
                    >
                        <ChevronLeft style={{ width: '30px', height: '30px' }} onClick={() => onBack()} />

                        {/* {shoppingState && (<ShoppingBag style={{ width: '23px', height: '23px', marginLeft: "20px" }} onClick={() => navigate('/shopping')} />)} */}
                    </div>

                    {/* 중앙 타이틀 */}
                    <div style={{ fontWeight: 'bold', color: "#000", fontSize: "18px" }}>
                        {t('coupons_5')}
                    </div>
                </div>

                <div style={{ position: "fixed", bottom: "63px", width: "100%", zIndex: "15", background: "#fff", boxShadow: "rgba(0, 0, 0, 0.1) -1px -2px 5px", padding: "15px" }}>
                    {coupon.uc_pin_status_cd === '01' ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            {/* <div
                                style={{
                                    margin: "0 auto",
                                    borderRadius: "10px",
                                    background: "#000",
                                    color: "#fff",
                                    fontWeight: "500",
                                    fontSize: "18px",
                                    padding: "15px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    width: "120px"
                                }}
                                onClick={handleClickComplete}
                            >
                                Complete
                            </div> */}
                            <div
                                style={{
                                    margin: "0 auto",
                                    borderRadius: "10px",
                                    background: "#ffbb3f",
                                    color: "#000",
                                    fontWeight: "500",
                                    fontSize: "18px",
                                    padding: "15px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    width: "100%",
                                    height: "55px"
                                }}
                                onClick={handleClickUseLink}
                            >
                                {t('coupons_42')}
                            </div>
                        </div>
                    ) : (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <div
                                style={{
                                    margin: "0 auto",
                                    borderRadius: "10px",
                                    background: "#e3e3e3",
                                    color: "#000",
                                    fontWeight: "500",
                                    fontSize: "18px",
                                    padding: "15px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    cursor: "pointer",
                                    width: "100%",
                                    height: "55px"
                                }}
                                onClick={handleDelete}
                            >
                                <Trash2 style={{ width: '22px', height: '22px', color: "#c90000" }} /> {t('coupons_50')}
                            </div>
                            <div
                                style={{
                                    margin: "0 auto",
                                    borderRadius: "10px",
                                    background: "#ffbb3f",
                                    color: "#000",
                                    fontWeight: "500",
                                    fontSize: "18px",
                                    padding: "15px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    width: "100%",
                                    height: "55px"
                                }}
                                onClick={handleClickAvailable}
                            >
                                {t('coupons_60')}
                            </div>
                        </div>

                    )}
                </div>

                <div
                    style={{
                        color: "#000",
                        textAlign: "left",
                        padding: "10px 15px",
                        display: "flex",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginTop: "50px"
                    }}
                >
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <div
                            style={{
                                padding: "5px",
                                borderRadius: "12px",
                                width: "40px",
                                height: "40px",
                                background: "#fff"
                            }}
                        >
                            <img src='/img/saycoin.png' style={{ width: "100%" }} />
                        </div>
                        <div style={{ fontWeight: "bold", fontSize: '18px' }}>
                            {Number(coupon.event_no) > 0 ? t('coupons_45') : coupon.is_gift > 0 ? `${coupon.purchaser_name}${t('coupons_46')}` : t('coupons_47')}
                        </div>
                    </div>
                </div>

                {/* {coupon?.is_gift === 1 && coupon?.uc_gift_message?.length > 0 && (
                    <div
                        style={{
                            width: '100%',
                            textAlign: 'center',
                            marginBottom: '15px',
                            position: 'relative',
                            padding: "0 15px",
                        }}
                    >
                        <div style={{
                            width: "100%",
                            height: "auto",
                            padding: "15px",
                            background: "#fff",
                            borderRadius: '8px',
                            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                            color: "#000",
                        }}>
                            <div style={{
                                textAlign: "left",
                                fontSize: "14px",
                                display: "flex",
                                justifyContent: "space-between",
                                cursor: "pointer"
                            }} onClick={() => setMessageDrop(e => !e)}>
                                <div style={{ display: "flex", gap: "7px", width: "calc(100% - 25px)" }}>
                                    <FontAwesomeIcon icon={faEnvelope} style={{ width: "19px", height: "19px", color: "#ffbb3f" }} />
                                    <div style={{
                                        wordBreak: "break-word",
                                        whiteSpace: "pre-wrap",
                                        flex: 1
                                    }}>
                                        "{coupon?.uc_gift_message ?? ""}"
                                    </div>
                                </div>
                                {messageDrop ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                            </div>
                            {
                                messageDrop && (
                                    <div style={{ padding: "10px 0 0", width: "100%", position: "relative", background: "#fff" }}>
                                        <img src='/newImg/messageCard.png' style={{ width: "300px", borderRadius: "10px", margin: "0 auto" }} />
                                        <div style={{ position: "absolute", top: "20px", left: "50%", transform: "translateX(-50%)", width: "280px" }}>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "80px",
                                                    resize: "none",
                                                    padding: "7px",
                                                    boxSizing: "border-box",
                                                    fontSize: "16px",
                                                    lineHeight: "1.5",
                                                    overflowWrap: "break-word",
                                                    whiteSpace: "pre-wrap", // 엔터 및 줄바꿈 유지
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontFamily: "inherit",
                                                    background: "#fc8796",
                                                    color: "#fff",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {coupon?.uc_gift_message ?? ""}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )} */}

                {/* 쿠폰 이미지 영역 */}
                <div
                    style={{
                        width: '100%',
                        textAlign: 'center',
                        marginBottom: '15px',
                        position: 'relative',
                        padding: "0 15px",
                    }}
                >
                    <div style={{
                        width: "100%",
                        height: "auto",
                        padding: "25px 15px",
                        background: "#fff",
                        borderRadius: '8px',
                        opacity: coupon.uc_pin_status_cd !== '01' ? '0.6' : '1',
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
                    }}>
                        <FallbackImage
                            src={coupon?.bc_ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${coupon.bc_ci_custom_image_filename}` : coupon.ci_goods_img_big}
                            style={{ width: "200px", height: "200px", borderRadius: "10px", border: "1px solid #f9f9f9", boxShadow: "0 1px 5px rgba(0, 0, 0, 0.1)" }}
                        />
                        <div style={{ fontSize: "14px", color: "gray", fontWeight: "500", textAlign: "center", marginTop: "10px", wordBreak: "break-all" }}>{coupon.ci_brand_name}</div>
                        <div style={{ fontSize: "16px", color: "#000", fontWeight: "bold", textAlign: "center", marginBottom: "10px", wordBreak: "break-all" }}>{coupon.ci_goods_name}</div>
                        <div style={{ width: "250px", fontSize: "14px", margin: "0 auto", color: "#000", padding: "10px", borderRadius: "10px", border: "1px solid #f9f9f9", boxShadow: "0 1px 5px rgba(0, 0, 0, 0.1)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }} onClick={handleClickCoupy}>
                            <Copy size={15} /> {t('coupons_61')}
                        </div>
                    </div>

                    {/* 사용완료 / 사용불가 도장 이미지 */}
                    {coupon.uc_pin_status_cd !== '01' && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '0px',
                                right: '15px',
                            }}
                        >
                            <img
                                src={
                                    coupon.uc_pin_status_cd === '02'
                                        ? '/newImg/complete_soda.png'
                                        : '/newImg/expiration_soda.png'
                                }
                                alt={coupon.usedType}
                                style={{ width: '100px' }}
                            />
                        </div>
                    )}
                </div>

                <div style={{ background: "#fff", padding: "15px 0 0" }}>
                    <div
                        style={{
                            display: 'flex',
                            borderBottom: '1px solid #ddd',
                            color: "#000",
                            justifyContent: "space-around"
                        }}
                    >
                        <div style={{ width: '100%', display: "flex", alignItems: 'center', justifyContent: "center", cursor: 'pointer', }} onClick={() => setActiveTab(0)}>
                            <div
                                style={{
                                    textAlign: 'center',
                                    padding: '0 0 15px',
                                    fontWeight: activeTab === 0 ? 'bold' : 'normal',
                                    borderBottom:
                                        activeTab === 0 ? '2px solid #000' : '2px solid transparent',
                                }}
                            >
                                {t('coupons_6')}
                            </div>
                        </div>

                        <div style={{ width: '100%', display: "flex", alignItems: 'center', justifyContent: "center", cursor: 'pointer', }} onClick={() => setActiveTab(1)}>
                            <div
                                style={{
                                    textAlign: 'center',
                                    padding: '0 0 15px',
                                    fontWeight: activeTab === 1 ? 'bold' : 'normal',
                                    borderBottom:
                                        activeTab === 1 ? '2px solid #000' : '2px solid transparent',
                                }}
                            >
                                {t('coupons_7')}
                            </div>
                        </div>
                    </div>
                </div>

                {activeTab === 0 ? (
                    // [선물정보]
                    <>
                        <div style={{
                            padding: '12px 15px',
                            background: "#fff",
                            marginBottom: "8px"
                        }}>
                            <div
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    padding: "15px 0",
                                    color: "#000",
                                    textAlign: "left"
                                }}
                            >
                                {t('coupons_12')}
                            </div>
                            <div
                                style={{
                                    border: '1px solid #f3f3f3',
                                    borderRadius: '5px',
                                    padding: '15px',
                                    backgroundColor: '#fafafa',
                                    marginBottom: '10px',
                                }}
                            >
                                <div
                                    style={{
                                        fontWeight: 'bold',
                                        color: '#000',
                                        fontSize: '14px',
                                        textAlign: "left",
                                        marginBottom: "15px"
                                    }}
                                >
                                    {t('coupons_8')}
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center"
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "#5492ff",
                                            borderRadius: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faBarcode}
                                            style={{
                                                padding: "8px",
                                                fontSize: "20px"
                                            }}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            color: "#7d7d7d",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            fontWeight: "500"
                                        }}
                                    >
                                        {t('coupons_15_0')}<br />
                                        {t('coupons_15_1')}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                padding: "15px",
                                background: "#fff",
                                marginBottom: "8px"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    padding: "10px 0px 15px",
                                    color: "#000",
                                    textAlign: "left"
                                }}
                            >
                                {t('coupons_13')}
                            </div>
                            <div style={{ borderRadius: '8px' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        fontSize: '15px',
                                        padding: '15px 10px',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        background: "#f5f5f5",
                                        borderRadius: "3px"
                                    }}
                                >
                                    <div style={{ color: '#000' }}>
                                        {t('coupons_16')}
                                    </div>
                                    <div style={{ color: '#5492ff', fontWeight: "bold", fontSize: "16px" }}>
                                        {changeNum(coupon?.bc_ci_sale_price ?? 0)} {coupon.uc_currency}
                                    </div>
                                </div>
                                <RowItem
                                    label={t('coupons_9')}
                                    value={coupon?.uc_expire_date ? formatUTCDateTime(coupon?.uc_expire_date)?.split(' ')[0] : t('coupons_59')}
                                />
                                <RowItem
                                    label={t('coupons_17')}
                                    value={coupon.bc_order_no}
                                />
                                <RowItem
                                    label={t('coupons_18')}
                                    value={coupon.ci_brand_name}
                                />
                                {/* ▼ 여기서 "주문일"을 "년-월-일 시:분:초"로 표시 */}
                                <RowItem
                                    label={t('coupons_10')}
                                    value={formatUTCDateTime(coupon.uc_exchange_time)}
                                />
                                <RowItem
                                    label={t('coupons_11')}
                                    value={
                                        coupon.uc_pin_status_cd === '01'
                                            ? t("coupons_24")
                                            : coupon.uc_pin_status_cd === '02'
                                                ? t("coupons_25")
                                                : t("coupons_26")
                                    }
                                />
                                <RowItem
                                    label={t('coupons_19')}
                                    value={t('coupons_21')}
                                />
                                <RowItem
                                    label={t('coupons_20')}
                                    value={t('coupons_21')}
                                />
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "12px 15px",
                                background: "#fff",
                                marginBottom: "8px"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    padding: "5px 0px",
                                    color: "#000",
                                    textAlign: "left"
                                }}
                            >
                                {t('coupons_14')}
                            </div>
                            <div style={{ width: "100%", padding: "5px 0", display: "flex", alignItems: 'flex-start', justifyContent: "space-between", marginBottom: "3px" }}>
                                <div style={{ display: "flex", alignItems: 'center', gap: "10px" }}>
                                    <div style={{ color: '#5492ff', display: "flex", alignItems: 'center', justifyContent: "center" }}><Tickets size={20} /></div>
                                    <div style={{ fontSize: "14px", color: "#000" }}>{t('coupons_27')}</div>
                                </div>
                                <div></div>
                            </div>
                            <div style={{ width: "100%", padding: "5px 0", display: "flex", alignItems: 'flex-start', justifyContent: "space-between", position: "relative" }}>
                                <div style={{ display: "flex", alignItems: 'center', gap: "10px" }}>
                                    <div style={{ color: '#5492ff', display: "flex", alignItems: 'center', justifyContent: "center" }}><MapPin size={20} /></div>
                                    <div style={{ fontSize: "14px", color: "#000", display: "flex", alignItems: "center" }}>
                                        {t('coupons_28')}
                                        {
                                            coupon?.ci_available_store && coupon?.ci_unavailable_store &&
                                            <Info size={14} style={{ color: "gray", marginLeft: "3px", cursor: "pointer" }} onClick={() => setNoticeBox(true)} />
                                        }
                                    </div>
                                </div>
                                <div
                                    style={{ background: "#f9f9f9", border: "1px solid #ebebeb", padding: "7px 10px", fontSize: "12px", display: "flex", alignItems: 'center', justifyContent: "center", color: "#757575", fontWeight: "500", cursor: "pointer" }}
                                    onClick={handleClickMap}>
                                    <div style={{ marginRight: "2px", color: "gray" }}><i className="fa-regular fa-map"></i></div>
                                    <div>{t('coupons_29')}</div>
                                </div>
                                {textBox && (
                                    <div style={{ position: "absolute", right: "0", bottom: "30px", color: "#ddd" }}>
                                        <img src='/newImg/textbox.png' style={{ width: "205px" }} />
                                        <X style={{ width: '22px', height: '22px', position: "absolute", right: "5px", top: '5px', color: "#9d9d9d", cursor: "pointer", zIndex: "1" }} onClick={() => setTextBox(false)} />
                                        <div style={{ position: "absolute", top: "45%", left: "50%", transform: 'translate(-50%, -55%)', fontSize: "13px", width: "100%" }}>
                                            {t('coupons_30_0')}<br />
                                            <span style={{ color: "#f3df35" }}>{t('coupons_30_1')}</span>{t('coupons_30_2')}
                                        </div>
                                    </div>
                                )}
                                {noticeBox && (
                                    <div style={{ position: "absolute", right: "0", bottom: "34px", width: "93%", background: "#fff", border: "1px solid #a5a5a5", padding: "20px", textAlign: "left", color: "#676767", zIndex: "2" }}>
                                        <X style={{ width: '22px', height: '22px', position: "absolute", right: "10px", top: '10px', color: "#9d9d9d", cursor: "pointer", zIndex: "3" }} onClick={() => setNoticeBox(false)} />
                                        <div style={{ fontSize: "16px", width: "100%", fontWeight: "bold", color: "#000" }}>{t('coupons_31')}</div>
                                        {
                                            coupon?.ci_available_store
                                                ?
                                                <>
                                                    <div style={{ fontSize: "11px", width: "100%", fontWeight: "500", marginTop: "10px", marginBottom: "2px" }}>{t('coupons_32')}</div>
                                                    <div style={{ fontSize: "11px", width: "100%", whiteSpace: 'pre-wrap' }}>{coupon.ci_available_store}</div>
                                                </>
                                                :
                                                ""
                                        }
                                        {
                                            coupon?.ci_unavailable_store
                                                ?
                                                <>
                                                    <div style={{ fontSize: "11px", width: "100%", fontWeight: "500", marginTop: "10px", marginBottom: "2px" }}>{t('coupons_33')}</div>
                                                    <div style={{ fontSize: "11px", width: "100%", whiteSpace: 'pre-wrap' }}>{coupon.ci_unavailable_store}</div>
                                                </>
                                                :
                                                ""
                                        }
                                    </div>
                                )}
                            </div>
                        </div>

                        <div
                            style={{
                                padding: "30px 15px",
                                background: "#fff",
                                marginBottom: "150px"
                                // marginBottom: coupon.uc_pin_status_cd === '01' ? "150px" : "50px"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '14px',
                                    lineHeight: '1.5',
                                    whiteSpace: 'pre-wrap',
                                    textAlign: 'left',
                                    color: "#000",
                                    wordBreak: "break-all"
                                }}
                            >
                                {coupon.ci_content}
                            </div>
                        </div>
                    </>
                ) : (
                    // [상품정보]
                    <div
                        style={{
                            padding: "15px",
                            background: "#fff",
                            marginBottom: "150px"
                            // marginBottom: coupon.uc_pin_status_cd === '01' ? "150px" : "50px"
                        }}
                    >
                        <div
                            style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                padding: "10px 0px 15px",
                                color: "#000",
                                textAlign: "left"
                            }}
                        >
                            {t('coupons_44')}
                        </div>
                        <div
                            style={{
                                fontSize: '14px',
                                lineHeight: '1.5',
                                whiteSpace: 'pre-wrap',
                                textAlign: 'left',
                                color: "#000",
                                borderTop: "2px solid #e7e7e7",
                                borderBottom: "1px solid #e7e7e7",
                            }}
                        >
                            <RowTable
                                label={t('coupons_51')}
                                value={"SodaGift"}
                            />
                            <RowTable
                                label={t('coupons_52')}
                                value={coupon.ci_affilate}
                            />
                            <RowTable
                                label={t('coupons_53')}
                                value={t('coupons_56')}
                            />
                            <RowTable
                                label={t('coupons_54')}
                                value={t('coupons_56')}
                            />
                            <RowTable
                                label={t('coupons_55')}
                                value={t('coupons_57')}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div >
    );
}

function RowItem({ label, value }) {
    return (
        <div
            style={{
                display: 'flex',
                fontSize: '15px',
                padding: '14px 5px',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: "1px solid #f9f9f9"
            }}
        >
            <div style={{ color: '#8b8b8b' }}>{label}</div>
            <div style={{ color: '#000' }}>{value}</div>
        </div>
    );
}

const RowTable = ({ label, value }) => (
    <div
        style={{
            display: 'flex',
            fontSize: '14px',
            fontWeight: "500",
            borderBottom: '1px solid #e7e7e7',
        }}
    >
        <div style={{ color: '#616161', width: "120px", background: "#ededed", padding: "10px" }}>{label}</div>
        <div style={{ color: '#000', flex: 1, whiteSpace: 'pre-wrap', padding: "10px", width: "calc(100% - 120px)" }}>{value}</div>
    </div>
);

export default CouponDetail_Soda;